import FocusTrap from "./modal-focus-trap";

// Manage a modal overlay, trapping focus and escape to close it.
//
// Note: this class only manages focus and closing. It does not completely handle
// nested modals.
export class ModalManager {
  static getInstance() {
    if (!ModalManager.instance) {
      ModalManager.instance = new ModalManager();
    }
    return ModalManager.instance;
  }

  constructor() {
    this.openedModal = null;
    this.previouslyFocused = null;
  }

  openModal(element, onClose = null) {
    this.openedModal = element;
    this.previouslyFocused = document.activeElement;
    this.enableEscapeListener();
    this.onClose = onClose;
    FocusTrap.trap(element);
    FocusTrap.focusFirstDescendant(element);
  }

  closeModal() {
    this.openedModal = null;
    this.disableEscapeListener();
    FocusTrap.untrap();
    if (this.previouslyFocused) {
      this.previouslyFocused.focus();
      this.previouslyFocused = null;
    }
  }

  enableEscapeListener() {
    window.addEventListener("keydown", this.onModalKeydown);
  }

  disableEscapeListener() {
    window.removeEventListener("keydown", this.onModalKeydown);
  }

  onModalKeydown = (event) => {
    if (!this.openedModal || !this.openedModal.contains(event.target)) {
      return;
    }

    if(!event.defaultPrevented && event.key === 'Escape') {
      this.onClose?.();
      this.closeModal();
      event.preventDefault();
    }
  }
}
